export const staticWorkItems = [
  {
    id: 'static-tasty-trails-refreshed',
    title: 'Tasty Trails Refreshed',
    year: '2026',
    stack: 'React + Supabase + AI APIs',
    summary:
      'Modern recipe platform with AI recipe suggestions, personalized browsing, dark mode, and a faster, cleaner, more polished experience.',
    description:
      'Tasty Trails was refreshed into a smoother React + Supabase recipe platform with AI recipe recommendations, personalised browsing, dark mode, improved filters, favourites, and a cleaner modern interface. It keeps the original recipe search, authentication, smooth animations, and healthy recipe focus while delivering a faster, more polished user experience.',
    links: [{ label: 'View Website', url: 'https://tastytrailsin.netlify.app' }],
  },
  {
    id: 'static-my-abhyaas',
    title: 'My Abhyaas',
    year: '2025',
    stack: 'React JS + Supabase',
    summary:
      'NIOS Class 10 and 12 study website with curated question papers and answer sheets like the real board exams.',
    description:
      'This website is built using a Supabase backend and a React JS frontend. It is a NIOS resource platform designed to help Class 10 and 12 students prepare for exams by providing curated question papers and answer keys that are structured similarly to real board exams. The site focuses on making study materials easy to access and well organized.',
    links: [{ label: 'View Website', url: 'https://myabhyaas.com' }],
  },
  {
    id: 'static-ai-trip-planner',
    title: 'AI Trip Planner',
    year: '2025',
    stack: 'React JS + Supabase + Advanced APIs',
    summary:
      'Trip planning website that uses weather, Google Maps and ChatGPT 5.2 to help plan trips at the right time.',
    description:
      'This website is built using a Supabase backend with a React JS frontend and is the most advanced website made by me so far. It uses advanced APIs combined using Supabase Edge Functions for better performance and security. The APIs include the weather API from {Weather API:https://www.weatherapi.com}, Google Maps API from {Google Cloud Console:https://console.cloud.google.com} and the AI API from {OpenAI:https://openai.com/api/}. This website helps users plan trips by choosing the right time and weather based on live data and AI suggestions.',
    links: [],
  },
  {
    id: 'static-2d-animations',
    title: '2D Animations',
    year: '2024',
    stack: 'Keynote + Final Cut Pro',
    summary:
      'YouTube Shorts with car animations, car feature evolution and tech UI and hardware evolution videos.',
    description:
      'These animations are made in Keynote by tracing over images instead of using PNG or JPEG files. This method requires a lot of patience but gives me more power over colors, lighting, wheel movement for cars, shadows, animations and proportions. Everything including the background and transitions is made in Keynote and the background music is added later using Final Cut Pro. The animations focus on how cars from specific brands, mainly Indian manufacturers, have evolved over time, along with tech hardware evolution and how technology sounds have changed.',
    links: [
      {
        label: 'View YouTube Channel Shorts',
        url: 'https://www.youtube.com/@letsmakeit-everything/shorts',
      },
    ],
  },
  {
    id: 'static-tasty-trails',
    title: 'Tasty Trails',
    year: '2024',
    stack: 'FlutterFlow + Supabase',
    summary:
      'Recipe website where I share tasty recipes with healthy options like vegan, sugar free and gluten free.',
    description:
      'This website showcases a Supabase backend combined with a FlutterFlow frontend. It includes features like search, authentication, dark mode and smooth animations. The website displays recipes that were tried and tested by us, with a focus on healthy options such as vegan, gluten free, and sugar free recipes. The goal was to make the app simple, clean and easy to use while learning backend and UI concepts.',
    links: [{ label: 'View Project', url: 'https://tastytrails.flutterflow.app' }],
  },
  {
    id: 'static-youtube-channel',
    title: 'YouTube Channel',
    year: '2022',
    stack: 'Videography + iMovie',
    summary:
      'Videos showing what I worked on in 2022, including Lego builds, stop motion and DIY projects.',
    description:
      'Earlier videos on my YouTube channel were edited using iMovie, and later I switched to Final Cut Pro as I learned more. I started building LEGO when I was around 6 years old and became really into it during the COVID-19 period from 2020 to 2022. In 2022, I got my first LEGO Technic set. Since then, most of the builds and videos on my YouTube channel have focused on Technic sets, alternate builds, instruction manuals and stop motion.',
    links: [
      {
        label: 'View YouTube Channel',
        url: 'https://www.youtube.com/@letsmakeit-everything',
      },
    ],
  },
];

export const staticContactItems = [
  {
    id: 'static-discord',
    title: 'Discord',
    description: 'car_addict_26',
    redirectLink: 'https://discord.com/users/1310835420430598167',
    iconUrl: '/discord.png',
    usedTimes: 0,
  },
  {
    id: 'static-whatsapp',
    title: 'WhatsApp',
    description: 'Aarav',
    redirectLink: 'https://wa.me/919500999638',
    iconUrl: '/whatsapp.png',
    usedTimes: 0,
  },
  {
    id: 'static-email',
    title: 'Email',
    description: 'aarav.kumta@gmail.com',
    redirectLink: 'mailto:aarav.kumta@gmail.com',
    iconUrl: '/gmail.png',
    usedTimes: 0,
  },
];
